<template>
  <div v-if="cardsPayment?.length">
    <template v-if="showOnlyDefault">
      <details-card-payment :card="defaultCard" hidden-after hidden-delete/>
    </template>
    <template v-else>
      <details-card-payment v-for="(card, index) of cardsPayment"
                          :hidden-after="cardsPayment.length == 1"
                          :hidden-delete="cardsPayment.length === 1"
                          :card="card"
                          :key="index" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useProfileStore } from '@/stores';
import DetailsCardPayment from '@/components/profile/payment/DetailsCardPayment.vue';

export default {
  name: 'ListCardsPayment',
  nameClassStyle: 'list-cards-payment',
  props: {
    showOnlyDefault: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DetailsCardPayment,
  },
  computed: {
    ...mapState(useProfileStore, ['cardsPayment']),
    defaultCard() {
      return this.cardsPayment.find((card) => card.is_default);
    },
  },
};
</script>

<style scoped lang="scss">
.--margin-top {
  margin-top: 20px;
}

:deep(.details-card-payment) {
  margin-bottom: var(--nxt-space-xxsmall);
}
</style>
